import "./ProductivityPage.scss";
import { DownOutlined } from "@ant-design/icons";
import { Button, Card } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency, formatWithCommas } from "../../assets/helpers";
import ActionHeader from "../../Reuseable/actionHeader/ActionHeader";
import ChartFilterModal from "../../Reuseable/actionHeader/ChartFilter";
import StackedBarChart from "../../Reuseable/StackedBar/StackedBarChart";
import {
  fetchProductivity,
  fetchProductivityDrrProjection,
} from "../../store/productivity";
import Donut from "./DonutChart/Donut";
import { ddrData, negativeData, positiveData } from "./productivityData";
import BarChartSkeleton from "../../Reuseable/Skeleton/BarchartSkeleton";

const ProductivityPage = () => {
  const [open, setOpen] = useState(false);

  const [primaryItems, setPrimaryItems] = useState([]);
  const [secondaryItems, setSecondaryItems] = useState([]);
  const [refresh, setRefresh] = useState(false);
    const { query } = useSelector((state) => state.filters);

  const { productivity, loading, drrProjection, drrProjectionLoading } =
    useSelector((state) => state.productivity);
  const { format } = useSelector((state) => state.priceFormat);
  const dispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = useState("team_member");
  const [selectedTrustMap, setSelectedTrustMap] = useState({
    team_member: [],
    team_leader: [],
  });

  useEffect(() => {
   if(Array.isArray(query?.trust_id)) {
     dispatch(fetchProductivity());
   }
  }, [dispatch,query]);

  useEffect(() => {
   
      if(Array.isArray(query?.trust_id)) {
     dispatch(fetchProductivityDrrProjection({ ...selectedTrustMap }));
   }
  }, [dispatch, refresh,query]);

  console.log(productivity,'productivity');
 

  return (
    <Card className="productivityPageMain">
      <ActionHeader
        heading="Productivity"
        primaryItems={primaryItems}
        secondaryItems={secondaryItems}
        setPrimaryItems={setPrimaryItems}
        showSecondaryItems={true}
        setSecondaryItems={setSecondaryItems}
        fetchData={fetchProductivity}
        fetchData2={fetchProductivityDrrProjection}
        setRefresh={setRefresh}
      />
      <div className="productivity_content">
        <div className="aumCards">
          <div className="header_sect">
            <h2>AUM</h2>
          </div>
          <div className="cardsWrapped">
            {loading ? (
              <Card loading={true} style={{ padding: "10px", width: "100%" }} />
            ) : (
              <div className="cardOne card_of_content">
                <p className="title_of_card">Value</p>
                <h2 className="valueStats">
                  {formatCurrency(productivity?.productivityS1?.aum, format)}
                </h2>
              </div>
            )}
            {loading ? (
              <Card loading={true} style={{ padding: "10px", width: "100%" }} />
            ) : (
              <div className="cardTwo card_of_content">
                <p className="title_of_card">Count</p>
                <div className="percent_wrap">
                  <h2 className="valueStats">
                    {formatWithCommas(
                      productivity?.productivityS1?.aum_count || 0
                    )}
                  </h2>
                  <span className="percentBox">0%</span>
                </div>
              </div>
            )}
            {loading ? (
              <Card loading={true} style={{ padding: "10px", width: "100%" }} />
            ) : (
              <div className="cardThree card_of_content">
                <Donut
                  series={[
                    productivity?.productivityS1?.pending_percentage || 0,
                    productivity?.productivityS1?.recovered_percentage || 0,
                  ]}
                />
              </div>
            )}
          </div>
        </div>
        <div className="graphWrapperSection">
          <div className="graphContainer">
            <div className="positiveGraph">
              <div className="titleForGraph">
                <h2>Positive</h2>
                <div className="totalCountSect">
                  <div className="overallValue_count border">
                    <h2 className="boldtitle">Overall Value:</h2>
                    <h3 className="statsText">
                      {" "}
                      {formatCurrency(
                        productivity?.productivityS2?.action_code_summary
                          ?.positive_action_codes?.loans_amount,
                        format
                      )}
                    </h3>
                  </div>
                  <div className="overallValue_count leftPadding ">
                    <h2 className="boldtitle">Count:</h2>
                    <h3 className="statsText">
                      {formatWithCommas(
                        productivity?.productivityS2?.action_code_summary
                          ?.positive_action_codes?.count
                      )}
                    </h3>
                  </div>
                </div>
              </div>
              {loading ? (
                <BarChartSkeleton />
              ) : (
                <StackedBarChart
                  title="Positive"
                  data={productivity?.productivityS2?.action_code_summary?.positive_action_codes?.items?.map(
                    (item) => ({
                      Positive: item?.loans_amount,
                      name: item?.action_code,
                      total_loans: item?.loans_amount,
                    })
                  )}
                  keys={positiveData?.keys}
                  tooltipType={"productivity"}
                  colors={positiveData?.colors}
                  keysVisible={false}
                  chartName="Portfolio"
                  yLabel=""
                  format_type="currency"
                  gridOptions={{
                    left: "0",
                    right: "0%",
                    bottom: "5%",
                    top: "10%",
                    stroke: "#E6E6E6",
                    strokeDasharray: "0",
                    vertical: false,
                  }}
                  // height={200}
                  margin={{ top: 0, right: 0, bottom: 3, left: 0 }}
                />
              )}
            </div>

            <div className="negativeGraph">
              <div className="titleForGraph">
                <h2>Negative</h2>
                <div className="totalCountSect">
                  <div className="overallValue_count border">
                    <h2 className="boldtitle">Overall Value:</h2>
                    <h3 className="statsText">
                      {formatCurrency(
                        productivity?.productivityS2?.action_code_summary
                          ?.negative_action_codes?.loans_amount,
                        format
                      )}
                    </h3>
                  </div>
                  <div className="overallValue_count leftPadding ">
                    <h2 className="boldtitle">Count:</h2>
                    <h3 className="statsText">
                      {formatWithCommas(
                        productivity?.productivityS2?.action_code_summary
                          ?.negative_action_codes?.count
                      )}
                    </h3>
                  </div>
                </div>
              </div>
              {loading ? (
                <BarChartSkeleton />
              ) : (
                <StackedBarChart
                  title="Negative"
                  tooltipMode=""
                  data={productivity?.productivityS2?.action_code_summary?.negative_action_codes?.items?.map(
                    (item) => ({
                      Negative: item?.loans_amount,
                      name: item?.action_code,
                      total_loans: item?.loans_amount,
                    })
                  )}
                  keys={negativeData?.keys}
                  tooltipType={"productivity"}
                  colors={negativeData?.colors}
                  keysVisible={false}
                  chartName="Trust"
                  gridOptions={{
                    left: "0",
                    right: "0%",
                    bottom: "5%",
                    top: "10%",
                    stroke: "#E6E6E6",
                    strokeDasharray: "0",
                    vertical: false,
                  }}
                  format_type="currency"
                  // height={200}
                  margin={{ top: 0, right: 0, bottom: 3, left: 0 }}
                />
              )}
            </div>
          </div>
          <div className="ddrProjection">
            <div className="positiveGraph">
              <div className="titleForGraph">
                <h2>DRR Projection</h2>
                <Button
                  style={{ height: "35px", fontWeight: 500 }}
                  onClick={() => setOpen(true)}
                >
                  Filter <DownOutlined />
                </Button>
              </div>
              {drrProjectionLoading ? (
                <BarChartSkeleton />
              ) : (
                <StackedBarChart
                  className="ddrProjectionMain"
                  title="Positive"
                  data={drrProjection?.portfolios?.[0]?.months}
                  keys={["total", "target"]}
                  // tooltipType={"attempts"}
                  tooltipMode="weekly"
                  colors={["#FE7F49", "#00B247"]}
                  keysVisible={true}
                  yLabel=""
                  chartName="Months"
                  gridOptions={{
                    left: "0",
                    right: "0%",
                    bottom: "5%",
                    top: "10%",
                    stroke: "#E6E6E6",
                    strokeDasharray: "0",
                    vertical: false,
                  }}
                  height={200}
                  margin={{ top: 0, right: 0, bottom: 3, left: 0 }}
                  format_type="currency"
                  drr={true}
                  dualBar={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ChartFilterModal
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        open={open}
        setOpen={setOpen}
        setSecondaryItems={setSecondaryItems}
        selectedTrustMap={selectedTrustMap}
        setSelectedTrustMap={setSelectedTrustMap}
        setRefresh={setRefresh}
      />
    </Card>
  );
};

export default ProductivityPage;
